
import React from 'react';
import '../styles/Page.css';
import '../styles/Portfolio.css';

const portfolioItems = [
  { id: 1, type: 'Photo', title: 'Neon Noir', image: 'https://via.placeholder.com/400x300.png?text=Photo+1' },
  { id: 2, type: 'Video', title: 'Cybernetic Dreams', image: 'https://via.placeholder.com/400x300.png?text=Video+1' },
  { id: 3, type: '3D Render', title: 'Metropolis 2077', image: 'https://via.placeholder.com/400x300.png?text=3D+1' },
  { id: 4, type: 'AI Art', title: 'Digital Consciousness', image: 'https://via.placeholder.com/400x300.png?text=AI+Art+1' },
  { id: 5, type: 'Photo', title: 'Urban Decay', image: 'https://via.placeholder.com/400x300.png?text=Photo+2' },
  { id: 6, type: '3D Render', title: 'Android Dreams', image: 'https://via.placeholder.com/400x300.png?text=3D+2' },
];

function Portfolio() {
  return (
    <div className="page-container">
      <div className="page-content">
        <h1 className="glitch" data-text="Portfolio">Portfolio</h1>
        <div className="portfolio-grid">
          {portfolioItems.map(item => (
            <div key={item.id} className="portfolio-item">
              <img src={item.image} alt={item.title} />
              <div className="portfolio-item-overlay">
                <h3>{item.title}</h3>
                <p>{item.type}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Portfolio;
